/**
 * @param {object} item - Item..
 * @param {object[]} columns - Column data.
 * @param {number} seasonNavId - Season nav ID.
 * @param {'totals'|'averages'|'benchmarkedTotals'|'benchmarkedAverages'} dataType - Data type.
 * @returns {object[]} Row data for the given player.
 */
export const composeRowData = (item, columns, seasonNavId, dataType) => ({
    year: item[0]?.substr(4, 4),
    club: item[1]?.club ?? '',
    opponent: item[1]?.opponent ?? '',
    round: item[1]?.round?.roundNumber,
    result: item[1]?.result ?? '',
    ...columns.reduce(
        (prev, curr) => ({
            ...prev,
            [curr.accessor]:
                seasonNavId === -1 &&
                (dataType === 'averages' || dataType === 'benchmarkedAverages')
                    ? item[1].averages?.[curr.accessor]?.value
                    : item[1].totals?.[curr.accessor]
        }),
        {}
    ),
    benchmarks: {
        ...columns.reduce(
            (prev, curr) => ({
                ...prev,
                [curr.accessor]:
                    item[1].averages?.[curr.accessor]?.benchmark ?? ''
            }),
            {}
        )
    }
});
